import apiCrud from '../../abstract/api-crud.js';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/bookkeepings/invoice-number-templates`;
export const modelName = 'numbertemplate';
export default {
  ...apiCrud({ baseUri, modelName }),
  makeDefault: async (data) => await axios.put(`${ baseUri }/${ data.id }/make-default`),
};
